// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import DOMPurify from 'dompurify';
import pages from './pages';
// import { app } from './lib/app';

Vue.config.productionTip = false;

// Sanitizing replacement for v-html: strips scripts / event handlers / dangerous markup so that
// guest- or channel-manager-controlled data (names, addresses, comments, ...) cannot inject script
// into the staff UI. Use this instead of v-html whenever the bound value is not developer-authored.
const setSafeHtml = (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value == null ? '' : String(binding.value));
};
Vue.directive('safe-html', { inserted: setSafeHtml, update: setSafeHtml });

pages();



// WEBPACK FOOTER //
// ./src/main.js